var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg095AngleHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "11.2,70 11.2,40 50,12.2 88.8,40 88.8,70",
    stroke: "#000",
    strokeWidth: 8,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg095AngleHalf);
export default __webpack_public_path__ + "static/media/09-5-angle-half.6112a24329dc28b128aa62029fbf5d14.svg";
export { ForwardRef as ReactComponent };